import type { GetDashboardSummary200SummaryRecentActivitiesItem } from './getDashboardSummary200SummaryRecentActivitiesItem';

export type GetDashboardSummary200Summary = {
  activeSubscriptions?: number;
  recentActivities?: GetDashboardSummary200SummaryRecentActivitiesItem[];
  totalOrders?: number;
  totalRevenue?: number;
};
